module.exports = __webpack_public_path__ + "img/save.9b7d7c09.svg";